import { Button, LinkAsButton, ProColors } from '@treatwell/treatwell-aura';
import { Trans, useTranslation } from 'react-i18next';
import { css } from '@emotion/react';
import { Wave1, Wave5 } from '../aphrodite';
import { isRedirectState, useFormContext } from '../state';
import {
  SegmentEventType,
  useSegmentContext,
} from '../features/segment-context';
import { Form, Title } from './templates';

export function StepFinalRedirectLogin() {
  const { t } = useTranslation('stepFinalRedirectLogin');
  const { state, onNext, onPrevious } = useFormContext();
  const { trackEvent } = useSegmentContext();

  // State was lost (refresh, newer session...). Go back to previous step
  // This is required because redirect state is not persisted in localStorage
  if (!isRedirectState(state) || !onNext) {
    onPrevious?.();
    return null;
  }

  return (
    <Form
      css={css({
        border: `1px solid ${ProColors.navy[400]}`,
        borderRadius: 8,
        padding: 32,
      })}
    >
      <div css={css({ width: 64 })}>
        <Wave5 color={ProColors.yellow[600]} strokeWidth={1.4} />
      </div>
      <Title
        text={
          <Trans
            t={t}
            i18nKey="message"
            transKeepBasicHtmlNodesFor={['br']}
            components={[<span css={css({ color: ProColors.teal[600] })} />]}
          />
        }
      />
      <div>
        <LinkAsButton
          to={state?.redirectURL || ''}
          flavor="primary"
          size="medium"
          onClick={() =>
            trackEvent(SegmentEventType.LOGIN_REDIRECT, {
              step: 'LoginRedirect',
            })
          }
        >
          {t('button')}
        </LinkAsButton>
      </div>

      <div
        css={css({
          height: 1,
          backgroundColor: ProColors.navy[400],
          position: 'relative',
        })}
      >
        <div
          css={{
            position: 'absolute',
            right: -10,
            bottom: 50,
            transform: 'scaleY(-1) rotate(211deg)',
            width: 177,
            height: 46,
          }}
        >
          <Wave1 color={ProColors.pink[600]} strokeWidth={1.2} />
        </div>
      </div>

      <div className="aura--copy-normal">{t('alternativeMessage')}</div>
      <div>
        <Button onClick={() => onNext()} flavor="secondary" size="medium">
          {t('alternativeButton')}
        </Button>
      </div>
    </Form>
  );
}
